import { PostAPI } from 'Components/Helper/Helpers';

export const InsertUser = async (request) => {
    return PostAPI(request, 'AgreementUserMaster/Insert');
};

export const Select = async (request) => {
    return PostAPI(request, 'AgreementUserMaster/Select');
};

export const VerifyOTP = async (request) => {
    return PostAPI(request, 'AgreementUserMaster/VerifyAgreementOTP');
};
